"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormControlLabelOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginLeft: undefined,
            marginRight: spacing(3),
        },
        label: {
            "&$disabled": {
                color: undefined,
            },
        },
    });
};
//# sourceMappingURL=MuiFormControlLabel.js.map